import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
// import { Network } from '@awesome-cordova-plugins/network/ngx';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
    TranslateModule
  ],
  providers: [
    // Network
  ]
})
export class CoreModule { }
